import(/* webpackMode: "eager" */ "/app/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/providers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Copilot"] */ "/app/components/copilot.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Feedback"] */ "/app/components/feedback.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BotMessage"] */ "/app/components/message.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/search-related.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SearchResults"] */ "/app/components/search-results.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AnimatedLoadingSteps","SearchSkeleton"] */ "/app/components/search-skeleton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Section"] */ "/app/components/section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ClearButton"] */ "/app/components/ui/clear-button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Logout"] */ "/app/components/ui/log-out.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["InternalAIProvider"] */ "/app/node_modules/.pnpm/ai@4.2.0_react@18.3.1_zod@3.25.76/node_modules/ai/rsc/dist/rsc-shared.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@14.2.1_@babel+core@7.29.7_@opentelemetry+api@1.9.1_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@14.2.1_@babel+core@7.29.7_@opentelemetry+api@1.9.1_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--font-sans\"}],\"variableName\":\"fontSans\"}");
